<template>
  <div>
    <PageHeader :schema="$schemas.mdfe">

    </PageHeader>
    <PageContent>
    </PageContent>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader';
import PageContent from '@/components/PageContent';
import Mdfe from '../model/Mdfe';
export default {
  name: 'CreateMdfe',
  components: {
    PageHeader,
    PageContent,
  },
  data() {
    return {
      mdfe: Mdfe.model,
    };
  },
  computed: {},
  mixins: [],
  methods: {
  },
  async mounted() {
  },
};
</script> 
